<template>
  <div class="nav-popup">
    <div class="nav-popup__header" @click="isOpen = !isOpen">
      <span class="nav-popup__title">{{ activeItem }}</span>
      <button type="button" class="btn-cloak">
        <icon fill="#dc4128" name="dropdown" width="15" height="8" />
      </button>
    </div>

    <div class="nav-popup__dropdown" v-show="isOpen">
      <div class="nav-popup__content">
        <div class="nav-popup__item" v-for="(item, index) in itemList" :key="`contribution-${index}`">
          <a class="nav-popup__link" :class="{ 'nav-popup__link--active': index === active }" @click.prevent="onSelect(index)">
            {{ item }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '../shared/Icon'

export default {
  components: {
    Icon
  },
  props: {
    itemList: {
      type: Array,
      default: () => []
    },
    active: Number
  },
  data () {
    return {
      isOpen: false
    }
  },
  computed: {
    activeItem () {
      return this.itemList[this.active]
    }
  },
  watch: {
    active () {
      this.isOpen = false
    }
  },
  created () {
    const self = this

    window.addEventListener('click', function (e) {
      if (self.isOpen && !self.$el.contains(e.target)) {
        self.isOpen = false
      }
    })
  },
  destroyed () {
    document.removeEventListener('click', null, false)
  },
  methods: {
    onSelect (index) {
      this.$emit('select', index)
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-popup {
  letter-spacing: 1px;
  margin-bottom: 52px;
  position: relative;

  &__title {
    @include make-active-item;
    display: inline-block;
    font-weight: 900;
    margin-right: 16px;
    max-width: calc(100% - 40px);
    position: relative;
    text-transform: uppercase;
  }

  &__dropdown {
    background-color: rgba($white, .95);
    box-shadow: 0 0 14px 0 rgba(0, 0, 0, 0.12);
    padding: 30px 20px;
    position: absolute;
    top: calc(100% + 9px + 3px + 10px);
    z-index: 1;
  }

  &__item {
    & + & {
      margin-top: 27px;
    }
  }

  &__link {
    color: $theme-black;
    display: inline-block;
    font-weight: 900;
    text-transform: uppercase;

    &:hover,
    &:active,
    &--active {
      @include make-active-item;

      text-decoration: none;
    }
  }
}
</style>
